import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import ajaxVoucher from '../util/remote/ajaxVoucher';

const initialState = { 
    statsLoaded: false,
    transactions: null,
    metaData: null,
    currentPage: 1,
    mounted: false,
    recentVouchers: null,
    stats:null,
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const MySaleContext = createContext();

export const MySaleProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const [filters, setFilters] = useState({ q: '', plan_id: '', status: '', source: '', from: '', to: '' });

  useEffect(()=>{
      if(state.mounted){
        getVoucherTransactions(false, true);
      }
    }, [state.currentPage, state.mounted])

  const getStats = async (refresh = false) => {
    if(!refresh && state.statsLoaded) return;
    if(refresh){
        dispatch({ type: 'stats', payload: initialState.stats });
        dispatch({ type: 'statsLoaded', payload: false });
    }
    const server_response  = await ajaxVoucher.fetchVendorStats();
    if(server_response.status === "OK"){
        dispatch({ type: 'stats', payload: server_response.details });
        dispatch({ type: 'statsLoaded', payload: true });
    }
  };

  const getVoucherTransactions = async (refresh = false, nextPage = false) => {
    if(!refresh && Array.isArray(state.transactions) && !nextPage) return;
    if(refresh){
        setCurrentPage(1);
        dispatch({ type: 'transactions', payload: null });
        dispatch({ type: 'metaData', payload: null });
    }
    const server_response  = await ajaxVoucher.fetchMyVouchers({ page: refresh ? 1 : state.currentPage, filters });
    if(server_response.status === "OK"){
        dispatch({ type: 'transactions', payload: server_response.details.data });
        dispatch({ type: 'metaData', payload: server_response.details.meta });
    }else{
        dispatch({ type: 'transactions', payload: '404' });
        dispatch({ type: 'metaData', payload: null });
    }
  };

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const setMounted = (value) => {
    dispatch({ type: 'mounted', payload: value });
  };

  const getRecentVouchers = async (refresh = false) => {
    if (!refresh && Array.isArray(state.recentVouchers)) return;
    const server_response = await ajaxVoucher.fetchMyRecentVouchers();
    if (server_response.status === "OK") {
      dispatch({ type: 'recentVouchers', payload: server_response.details });
    }else{
      dispatch({ type: 'recentVouchers', payload: '404' });
    }
  };

 

  return(
    <MySaleContext.Provider value={{
      ...state,
      filters,
      setFilters,
      dispatch,
      getStats,
      getVoucherTransactions,
      setCurrentPage ,
      setMounted,
      getRecentVouchers,
      }}>
      {children}
    </MySaleContext.Provider>
  )

}

export const useMySale = ()=>useContext(MySaleContext);

